import { client } from 'lib/evi-api-gateway';

// 學校資源庫頁面
const url = `${process.env.REACT_APP_API_URL_RESOURCE}/api`;

// 获取清单列表，文件夹里面的资料
export async function getResourceList(params: any) {
  return client.post({
    url: `${url}/playlist/get_list`,
    form: {
      ...params
    }
  });
}
// 一个清单里面的详情课件
export async function getListDetail(params: any) {
  return client.post({
    url: `${url}/playlist/get_resource_list`,
    form: {
      id: params
    }
  });
}
// 删除清单列表项
export async function deleteResourceList(params: any) {
  return client.post({
    url: `${url}/playlist/delete`,
    form: {
      id: params
    }
  });
}

export async function deleteListDetail(params: any) {
  return client.post({
    url: `${url}/playlist/delete_resource`,
    form: {
      ...params
    }
  });
}
